import { Routes, Route } from 'react-router';
import Header from './components/layout/Header.jsx';
import Footer from './components/layout/Footer.jsx';
import RouteSeo from './components/common/RouteSeo.jsx';
import Home from './pages/Home.jsx';
import NotFound from './pages/NotFound.jsx';
import BlogList from './pages/blogs/BlogList.jsx';
import BlogPost from './pages/blogs/BlogPost.jsx';
import ProjectsList from './pages/projects/ProjectsList.jsx';
import ProjectDetail from './pages/projects/ProjectDetail.jsx';
import EventsPage from './pages/events/EventsPage.jsx';
import EventDetail from './pages/events/EventDetail.jsx';
import PeoplePage from './pages/people/PeoplePage.jsx';
import DisciplinesIndex from './pages/disciplines/DisciplinesIndex.jsx';
import DisciplinePage from './pages/disciplines/DisciplinePage.jsx';

export default function App() {
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/disciplines" element={<DisciplinesIndex />} />
          <Route path="/disciplines/:slug" element={<DisciplinePage />} />

          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          <Route path="/projects" element={<ProjectsList />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />

          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/:slug" element={<EventDetail />} />

          <Route path="/people" element={<PeoplePage />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <RouteSeo />
    </>
  );
}
